import React from 'react';
import { ModuleContentTemplate } from './ModuleContentTemplate';
import { module4Config } from '../config/moduleConfigs';

interface User {
  id: string;
  email: string;
  fullName: string;
  company: string;
  role: string;
  status: string;
}

interface Module4ContentProps {
  user: User | null;
  onLogout: () => void;
  isPreviewMode?: boolean;
  invitationEmail?: string;
  isAdminMode?: boolean;
  inviteToken?: string;
}

export function Module4Content({ 
  user, 
  onLogout, 
  isPreviewMode = false, 
  invitationEmail, 
  isAdminMode = false, 
  inviteToken 
}: Module4ContentProps) {
  return (
    <ModuleContentTemplate
      user={user}
      onLogout={onLogout}
      moduleId={4}
      moduleConfig={module4Config}
      isPreviewMode={isPreviewMode}
      invitationEmail={invitationEmail}
      isAdminMode={isAdminMode}
      inviteToken={inviteToken}
    />
  );
}

